var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRugby7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Pictogram",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 144 144",
    style: {
      enableBackground: "new 0 0 144 144"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M57.6,71.2l-47.3,47.3c-2,2-2,5.3,0,7.3c2,2,5.3,2,7.3,0l20.3-20.3h41.5c1.3,0,2.6-0.5,3.6-1.5c1-1,1.5-2.3,1.5-3.6 c0-1.3-0.5-2.6-1.5-3.6L57.6,71.2z M57.6,85.7l9.4,9.4H48.2L57.6,85.7z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 105.6,
    cy: 39.8,
    r: 9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.5,57.9c-0.9-0.7-2-1-3-1s-2.1,0.3-3,1c-2.7,2.1-4.8,4.9-5.9,8.2h-4.7L78.3,31.6C77.3,30.6,76,30,74.6,30H54.1 c-2.8,0-5.1,2.3-5.1,5.1s2.3,5.1,5.1,5.1h18.4l7.9,7.9L61.2,67.5l16.4,16.4l19.3-19.2L107,74.9c1,1,2.3,1.5,3.6,1.5h6.7 c1.1,3.5,3.2,6.5,6.1,8.7c0.9,0.7,2,1,3,1s2.1-0.3,3-1c4.1-3.1,6.8-8,6.8-13.6C136.3,65.9,133.6,61,129.5,57.9z M127.9,82.9 c-0.4,0.3-0.9,0.5-1.4,0.5c-0.5,0-1-0.2-1.4-0.5c-1.7-1.3-3.2-3-4.2-4.9c-1-2-1.6-4.2-1.6-6.5c0-2.3,0.5-4.5,1.6-6.5 c1-1.9,2.4-3.6,4.2-4.9c0.4-0.3,0.9-0.5,1.4-0.5c0.5,0,1,0.2,1.4,0.5c1.7,1.3,3.2,3,4.2,4.9c1,2,1.6,4.2,1.6,6.5s-0.5,4.5-1.6,6.5 C131,79.9,129.6,81.6,127.9,82.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRugby7);
export default __webpack_public_path__ + "static/media/rugby7.fa7a6b69640d281371fa30e38c0eecef.svg";
export { ForwardRef as ReactComponent };